import { render } from "./email-report.vue?vue&type=template&id=515e4bd5&lang=pug"
import script from "./email-report.vue?vue&type=script&lang=js"
export * from "./email-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__